import * as API_CONSTANT from "../constants";

export const getPayrollTimeFrameAll = ({ startTime, endTime }) =>
    fetch(`${API_CONSTANT.cnp_v1_fe_path}/payroll/timeframe/get/all`, {
      method: "POST",
      headers: API_CONSTANT.headers,
      body: JSON.stringify({
        startTime,
        endTime,
      }),
    }).then((res) => res.json());

export const getPayrollTimeFrameByCoid = ({ coid, startTime, endTime }) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/payroll/timeframe/get/coid`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({
      coid,
      startTime,
      endTime,
    }),
  }).then((res) => res.json());

export const updatePayroll = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/payroll/update/status`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());

export const bulkDisbursed = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/payroll/bulk/disbursed`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());

export const bulkRevertProcessing = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/payroll/bulk/reprocess`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());

export const generateRHB = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/payroll/rhb/generate`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());

export const payrollFileClose = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/payroll/file/close`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());
